import { render, staticRenderFns } from "./ExportRecord.vue?vue&type=template&id=39dece7b&scoped=true&"
import script from "./ExportRecord.vue?vue&type=script&lang=js&"
export * from "./ExportRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExportRecord.vue?vue&type=style&index=0&id=39dece7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dece7b",
  null
  
)

export default component.exports